/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {logout} from '../../common/login/actions';
import {removeErrors} from '../../common/app/actions';
import {fetchIsBarReportOpen, openBarReport, setReportIsOpen} from '../../common/report/actions';
import {openMessage} from '../../common/components/messages/actions';
import {openReportCashboxesCounter} from '../../common/menu/report/cashboxes/actions';
import moment from 'moment';

class OpenReport extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        logout: React.PropTypes.func,
        openReportCashboxesCounter: React.PropTypes.func,
        setReportIsOpen: React.PropTypes.func,
        fetchIsBarReportOpen: React.PropTypes.func,
        removeErrors: React.PropTypes.func,
        openBarReport: React.PropTypes.func,
        openMessage: React.PropTypes.func,
        bar: React.PropTypes.object,
        error: React.PropTypes.object,
        deviceId: React.PropTypes.number
    };

    constructor(props) {
        super(props);
        this.doOpenBarReport = this.doOpenBarReport.bind(this);
        this.showAlert = this.showAlert.bind(this);
    }

    componentWillUnmount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    componentWillMount() {
        const {fetchIsBarReportOpen, bar} = this.props;
        fetchIsBarReportOpen(bar.get('id'));
    }

    showAlert() {
        const {openMessage, setReportIsOpen, removeErrors, msg} = this.props;
        removeErrors();
        setReportIsOpen(true);
        openMessage(msg.openReport.alreadyOpen);
    }

    doOpenBarReport() {
        const {bar, openBarReport, openReportCashboxesCounter} = this.props;
        moment.locale('cs');
        openBarReport(bar.get('id'), moment(new Date()).format('dddd') + ' - POS')
            .payload.promise
            .then(res => {
                if (!!res && res.status === 409) {
                    this.showAlert();
                } else {
                    openReportCashboxesCounter(true);
                }
            })
            .catch(res => {
                if (!!res && res.status === 409) {
                    this.showAlert();
                }
            });
    }

    render() {
        const {logout, bar, error, deviceId, msg} = this.props;

        return (
            <div id="login-page" className="pageNotification">
                <h1 className="pageNotification-logo">{msg.global.appName}</h1>
                <div className="pageNotification-content">
                        <h2 className="pageNotification-title">{msg.openReport.title}</h2>

                        <div className="pageNotification-row pageNotification-text">
                            {msg.openReport.text1} "{bar.get('name')}" {msg.openReport.text2}<br/>
                            {msg.openReport.text3}
                        </div>

                        {!!error &&
                        <div className="pageNotification-row">
                          <div className="errors">
                            <ul>
                                {error.map((err, i) =>
                                    <li key={`error-key-${i}`}>{err}</li>
                                )}
                            </ul>
                        </div>
                        </div>
                        }

                        <br />

                        <div className="pageNotification-row">
                            <button className="btn btn-green" onClick={() => this.doOpenBarReport()}>
                                {msg.openReport.open}
                            </button>
                        </div>

                        <div className="pageNotification-row">
                            <button className="btn" onClick={() => logout(deviceId)}>
                                {msg.global.logout}
                            </button>
                        </div>

                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    error: state.app.get('error'),
    deviceId: state.device.get('id')
}), {
    logout, fetchIsBarReportOpen, openBarReport, removeErrors, openMessage, setReportIsOpen, openReportCashboxesCounter
})(OpenReport);



// WEBPACK FOOTER //
// ./src/browser/report/OpenReport.js